import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 26,
	viewBox: "0 0 17 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.41697 1.76884C5.59327 1.76884 3.29449 4.05939 3.29449 6.89133C3.29449 9.71144 5.59342 12.0138 8.41697 12.0138C11.2416 12.0138 13.5383 9.71148 13.5383 6.89133C13.5383 4.05935 11.2418 1.76884 8.41697 1.76884ZM8.41697 12.8708C5.11567 12.8708 2.43027 10.1855 2.43027 6.89133C2.43027 3.58542 5.11554 0.900013 8.41697 0.900013C11.7184 0.900013 14.4037 3.58542 14.4037 6.89133C14.4037 10.1855 11.7183 12.8708 8.41697 12.8708Z",
			fill: "#272525",
			stroke: "#272525",
			strokeWidth: .2
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-2-outside-1_19_1037",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 11,
			width: 17,
			height: 15,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				y: 11,
				width: 17,
				height: 15
			}), /* @__PURE__ */ _jsx("path", { d: "M1.66542 24.3307H15.4528V19.6715C15.4528 15.8693 12.3603 12.7708 8.55906 12.7708C4.75897 12.7708 1.66542 15.8693 1.66542 19.6715V24.3307ZM15.7849 25H1.33328C1.14903 25 1 24.8473 1 24.6593V19.6715C1 15.5053 4.39164 12.1139 8.55906 12.1139C12.7277 12.1139 16.117 15.5053 16.117 19.6715V24.6593C16.117 24.8473 15.9692 25 15.7849 25Z" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.66542 24.3307H15.4528V19.6715C15.4528 15.8693 12.3603 12.7708 8.55906 12.7708C4.75897 12.7708 1.66542 15.8693 1.66542 19.6715V24.3307ZM15.7849 25H1.33328C1.14903 25 1 24.8473 1 24.6593V19.6715C1 15.5053 4.39164 12.1139 8.55906 12.1139C12.7277 12.1139 16.117 15.5053 16.117 19.6715V24.6593C16.117 24.8473 15.9692 25 15.7849 25Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.66542 24.3307V24.5307H1.46542V24.3307H1.66542ZM15.4528 24.3307H15.6528V24.5307H15.4528V24.3307ZM1.66542 24.1307H15.4528V24.5307H1.66542V24.1307ZM15.2528 24.3307V19.6715H15.6528V24.3307H15.2528ZM15.2528 19.6715C15.2528 15.9796 12.2496 12.9708 8.55906 12.9708V12.5708C12.471 12.5708 15.6528 15.7591 15.6528 19.6715H15.2528ZM8.55906 12.9708C4.86966 12.9708 1.86542 15.9796 1.86542 19.6715H1.46542C1.46542 15.7591 4.64829 12.5708 8.55906 12.5708V12.9708ZM1.86542 19.6715V24.3307H1.46542V19.6715H1.86542ZM15.7849 25.2H1.33328V24.8H15.7849V25.2ZM1.33328 25.2C1.03432 25.2 0.8 24.9535 0.8 24.6593H1.2C1.2 24.7412 1.26374 24.8 1.33328 24.8V25.2ZM0.8 24.6593V19.6715H1.2V24.6593H0.8ZM0.8 19.6715C0.8 15.3948 4.28121 11.9139 8.55906 11.9139V12.3139C4.50207 12.3139 1.2 15.6158 1.2 19.6715H0.8ZM8.55906 11.9139C12.8381 11.9139 16.317 15.3949 16.317 19.6715H15.917C15.917 15.6157 12.6172 12.3139 8.55906 12.3139V11.9139ZM16.317 19.6715V24.6593H15.917V19.6715H16.317ZM16.317 24.6593C16.317 24.9526 16.0848 25.2 15.7849 25.2V24.8C15.8536 24.8 15.917 24.7421 15.917 24.6593H16.317Z",
			fill: "#272525",
			mask: "url(#path-2-outside-1_19_1037)"
		})
	]
});
export { SvgProfile as ReactComponent };
